import { Autocomplete, TextField } from '@mui/material';
import React from 'react';
import { Control, Controller, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { EmployeesIndexed } from '~/data/employees';
import { Form } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/useScheduleChanges';

type Props = {
  control: Control<Form>;
  managers: number[];
  allEmployees: EmployeesIndexed;
  index: number;
};

export const ManagerComponent = (props: Props) => {
  const { control, managers, allEmployees, index } = props;

  const { t } = useTranslation();
  useWatch({
    control,
    name: `schedule.${index}.empPosition.fInternalPositionUnit`,
  });

  return (
    <Controller
      control={control}
      rules={{
        required: false,
        validate: (value) => {
          if (!value) return true;
          // Is valid employee Id
          const num = parseInt(value);
          return !isNaN(num);
        },
      }}
      name={`schedule.${index}.empPosition.fInternalPositionManager`}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <Autocomplete
          placeholder={''}
          options={managers}
          getOptionLabel={(c) =>
            `${allEmployees[c]?.fEmpLastName || ''}, ${
              allEmployees[c]?.fEmpFirstName || ''
            }`
          }
          onChange={(e, value) => {
            onChange(value ? value.toString() : '-1');
          }}
          value={managers.find((mg) => mg.toString() === value) || null}
          size={'small'}
          data-testid="int-position-manager-autocomplete"
          renderInput={(params) => (
            <TextField
              {...params}
              label={t('laManager')}
              error={!!error}
              helperText={error?.message}
              data-testid="int-position-manager-input"
              InputLabelProps={{ shrink: true }}
            />
          )}
          fullWidth={true}
        />
      )}
    />
  );
};
